
import { Link } from "@mui/material";
import { Box } from "@mui/system";
import PageRoutes from "../Config/PageRoutes";

const FeedbackButton = (props) => {

    return (
        <Box className="sidebarButtonWrapper feedbackButtonWrapper">
            <Link target='_blank' href='https://ec.europa.eu/eusurvey/runner/5cbe1eaa-fd1e-87fb-6dea-a1c84216d504'>
                <Box className="menuItem">
                    Give us feedback
                </Box>
            </Link>
        </Box>
    );

}

export default FeedbackButton;